/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import moment from 'moment';
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import {InformationModalComponent} from "../information-modal/information-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {RequestService} from "../../../../services/request/request.service";
import {ListRecipientsModalComponent} from "../list-recipients-modal/list-recipients-modal.component";
import {ConstantsService} from "../../../../services/constants/constants.service";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
@Component({
  selector: 'app-recipients-details-table',
  templateUrl: './recipients-details-table.component.pug',
  styleUrls: ['./recipients-details-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class RecipientsDetailsTableComponent implements OnInit, OnChanges {

  @Input() total = 0;
  @Input() filterCount = 0;
  @Input() renderComp:any = 0
  @Input() backgroundChecks: any;
  @Input() flowsSelected: any;
  @Input() typeOfCheck = ConstantsService.REFERENCE_CHECK;
  @Input() disable_edit = false;
  @Input() isReference = true;
  @Input() templateMode: any;
  @Output() updateTotal = new EventEmitter();
  @Output() resetDraft = new EventEmitter();
  @Output() updateFilter = new EventEmitter();
  @Output() countMobileNos = new EventEmitter();
  @Output() errorCount = new EventEmitter();
  @Output() totalChecks = new EventEmitter();
  @Output() allDeleted = new EventEmitter();
  totalExitRecipientsDetails: any[] = [];
  totalReferenceRecipientsDetails: any[] = [];
  totalBackgroundCheckRecipientsDetails: any[] = [];
  totalPulseRecipientsDetails: any[] = [];
  loading = false;
  id = -1;
  pagination = {
    "rowsPerView": 20,
    "currentPage": 1
  }
  sortCriteria = {
    "sortString": 'recipient',
    "sortOrder": 'asc',
    "sortOptions": [
      {
        'label': "Recipient",
        'type': "word",
        'value': "recipient"
      },
      {
        'label': "Email",
        'type': "word",
        'value': "email"
      },
      {
        'label': "End date",
        'type': "number",
        'value': "end_date"
      },
    ]
  }
  searchTerm = '';
  errorRecipients = 0;
  warningRecipients = 0;
  recipientsWithoutMobile = 0;
  draftUid: string | null = '';
  draftReferenceUid: string | null = '';
  referenceDraftUid: string | null = '';
  filterBy = {
    'error': false,
    'warning': false
  };
  phoneUtil = PhoneNumberUtil.getInstance();
  private bsModalRef: any;

  constructor(private modalService: BsModalService,
    private requestService: RequestService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      if (localStorage.getItem('draft_uid')) {
        this.draftUid = localStorage.getItem('draft_uid');
      }
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      if (localStorage.getItem('draft_reference_uid')) {
        this.draftUid = localStorage.getItem('draft_reference_uid');
      }
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
      if (localStorage.getItem('draft_background_check_uid')) {
        this.draftUid = localStorage.getItem('draft_background_check_uid');
      }
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      if (localStorage.getItem('draft_pulse_uid')) {
        this.draftUid = localStorage.getItem('draft_pulse_uid');
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.retrieveReferenceDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK ) {
      this.retrievePulseDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK ) {
      this.retrieveBackgroundCheckDraftTableData();
    }
  }

  getMetaData() {
    this.requestService.metaExit(localStorage.getItem('draft_uid')).subscribe((data: any) => {
      this.errorRecipients = data['error_count'];
      this.warningRecipients = data['warning_count'];
      let payload = {
        "error": this.errorRecipients,
        "warning": this.warningRecipients
      }
      this.errorCount.emit(payload);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  getReferenceMetaData() {
      this.requestService.metaBackgroundCheck(localStorage.getItem('draft_reference_uid'), false).subscribe((data: any) => {
      this.errorRecipients = data['error_count'];
      this.warningRecipients = data['warning_count'];
      let payload = {
        "error": this.errorRecipients,
        "warning": this.warningRecipients
      }
      this.errorCount.emit(payload);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deprecatedGetReferenceMetaData() {
    this.requestService.deprecatedMetaReference(localStorage.getItem('draft_reference_uid')).subscribe((data: any) => {
        this.errorRecipients = data['error_count'];
        this.warningRecipients = data['warning_count'];
        let payload = {
          "error": this.errorRecipients,
          "warning": this.warningRecipients
        }
        this.errorCount.emit(payload);
      },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }
  getBackgroundCheckMetaData() {
    // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
    this.requestService.metaBackgroundCheck(localStorage.getItem('draft_background_check_uid')).subscribe((data: any) => {
      this.errorRecipients = data['error_count'];
      this.warningRecipients = data['warning_count'];
      let payload = {
        "error": this.errorRecipients,
        "warning": this.warningRecipients
      }
      this.errorCount.emit(payload);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  getPulseMetaData() {
    this.requestService.metaPulse(localStorage.getItem('draft_pulse_uid')).subscribe((data: any) => {
      this.errorRecipients = data['error_count'];
      this.warningRecipients = data['warning_count'];
      if(this.recipientsWithoutMobile>0) this.errorRecipients+=this.recipientsWithoutMobile
      let payload = {
        "error": this.errorRecipients,
        "warning": this.warningRecipients
      }
      this.errorCount.emit(payload);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }


  setValues(totalRecipientsDetails) {

    let END_DATE_MONTHS = moment.months();
    this.recipientsWithoutMobile = 0;
    totalRecipientsDetails.forEach(val => {


      if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
        val['end_date_month'] = !val['end_date_month'] || !END_DATE_MONTHS[val['end_date_month'] - 1] ? '' : END_DATE_MONTHS[val['end_date_month'] - 1];
      }
      if (val['mobile_phone'] && (
        val['country_code'] && (val['country_code'].trim().length>1 || (
          val['country_code'].trim().length == 1 && /^-?\d+$/.test(val['country_code'])
        ))
      ) && val['mobile_phone']!='' && val['mobile_phone']!='null') {
        val['valid_mobile'] = true;
        if (!val['country_code'].startsWith('+')) {
          val['country_code'] = '+' + val['country_code'];
        }
        let phone = val['country_code'] + val['mobile_phone'];
        try {
          const parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
          val['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
        } catch (error) {
          console.log("Phone number parsing error: ", error)
          if (val['mobile_phone'].length > 0) val['mobile'] = val['country_code'] + ' ' + val['mobile_phone'];
        }
      } else {
        val['valid_mobile'] = false;
        if(val['meta']['error_fields'].length==0){
        this.recipientsWithoutMobile+=1
        }
      }
      if(val['meta']['error_fields'].length>0 || val['meta']['warning_fields'].length>0){
        val['meta']['isInitialsSet']=true;
      }
    })
    this.countMobileNos.emit(this.recipientsWithoutMobile);
  }

  filter(event, type) {
    this.filterBy[type] = event.currentTarget.checked;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.retrieveReferenceDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.retrievePulseDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      this.retrieveBackgroundCheckDraftTableData();
    }
    this.updateFilter.emit(this.filterBy);
  }

  deleteRecipient(data) {
    this.draftUid = data['draft_uid'];
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.retrieveRecipientTableData();
      this.total = data['total_exits'];
    } else if(this.typeOfCheck === ConstantsService.PULSE_CHECK){
      this.retrievePulseDraftTableData();
      this.total = data['total_pulses'];
    } else if(this.typeOfCheck === ConstantsService.BACKGROUND_CHECK){
      this.retrieveBackgroundCheckDraftTableData();
      this.total = data['total_external_checks'];
    } else {
      this.retrieveReferenceDraftTableData();
      this.total = data['total_external_checks'];
    }
    let dataToEmit = {
      'total': this.total
    }
    this.updateTotal.emit(dataToEmit);
  }

  editRecipient(data) {
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.draftUid = data['draft_uid'];
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.draftReferenceUid = data['draft_check_uid'];
      this.retrieveReferenceDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.draftReferenceUid = data['draft_pulse_uid'];
      this.retrievePulseDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
      this.draftReferenceUid = data['draft_reference_uid'];
      this.retrieveBackgroundCheckDraftTableData();
    }
  }

  editbcgRecpient(data){
      if(this.templateMode) {
          this.retrieveReferenceDraftTableData();
      }

  }

  onSearchChange(searchOptions) {
    if (searchOptions !== undefined) {
      this.searchTerm = searchOptions.value;
    } else {
      this.searchTerm = '';
    }
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.retrieveReferenceDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.retrievePulseDraftTableData();
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      this.retrieveBackgroundCheckDraftTableData();
    }
  }

  showInformationModal() {
    this.bsModalRef = this.modalService.show(InformationModalComponent, {
      class: 'modal-dialog-centered modal-dimensions1',
      initialState: {
        "checkType": this.typeOfCheck
      }
    });
  }

  retrieveRecipientTableData() {
    this.requestService.retrieveDraftExit(localStorage.getItem('draft_uid'), '', 6, 1, '', '', this.filterBy).subscribe((data: any) => {
      this.totalExitRecipientsDetails = data['exits'];
      this.total = data['total_exits'];
      this.setValues(this.totalExitRecipientsDetails);
      if (this.total === 0) {
        this.errorRecipients = 0;
        this.warningRecipients = 0;
        let payload = {
          "error": this.errorRecipients,
          "warning": this.warningRecipients
        }
        this.errorCount.emit(payload);
      } else {
        this.getMetaData();
      }
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  areAllChecksDeleted(data: any[]): boolean {
      return data.every(item => {
        const checks = item.checks;

        // No checks → false
        if (!checks || Object.keys(checks).length === 0) {
          return false;
        }

        return Object.values(checks).every(
          (check: any) => check.is_deleted === true
        );
      });
  }

  retrieveReferenceDraftTableData() {
    this.requestService.retrieveDraftBackgroundCheck(localStorage.getItem('draft_reference_uid'), '', 6, 1, '', '', this.filterBy, undefined, false).subscribe((data: any) => {
        this.totalReferenceRecipientsDetails = data['external_checks'];
        this.total = data['total_external_checks'];
        this.totalChecks.emit(data['total_background_checks']);
        if(this.templateMode) {
            this.allDeleted.emit(this.areAllChecksDeleted(this.totalReferenceRecipientsDetails))
        }
        this.setValues(this.totalReferenceRecipientsDetails);
        if (this.total === 0) {
          this.errorRecipients = 0;
          this.warningRecipients = 0;
          let payload = {
            "error": this.errorRecipients,
            "warning": this.warningRecipients
          }
          this.errorCount.emit(payload);
        } else {
          this.getReferenceMetaData();
        }
      },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_reference_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )

  }

  retrieveBackgroundCheckDraftTableData() {
    let checks: any;
    checks = this.backgroundChecks

    // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
    this.requestService.retrieveDraftBackgroundCheck(
      localStorage.getItem('draft_background_check_uid'),
      '', 6, 1, '', '',
      this.filterBy, checks
    ).subscribe((data: any) => {
        this.totalBackgroundCheckRecipientsDetails = data['external_checks'];
        this.total = data['total_external_checks'];
        this.setValues(this.totalBackgroundCheckRecipientsDetails);
        if (this.total === 0) {
          this.errorRecipients = 0;
          this.warningRecipients = 0;
          let payload = {
            "error": this.errorRecipients,
            "warning": this.warningRecipients
          }
          this.errorCount.emit(payload);
        } else {
          this.getBackgroundCheckMetaData();
        }
      },
      (err: any) => {
        if (err.status === 404) {
          // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
          localStorage.removeItem('draft_background_check_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  retrievePulseDraftTableData() {
    this.loading = true;
    this.requestService.retrieveDraftPulse(localStorage.getItem('draft_pulse_uid'), '', 6, 1, '', '', this.filterBy).subscribe((data: any) => {
      this.totalPulseRecipientsDetails = data['pulses'];
      this.total = data['total_pulses'];
      this.setValues(this.totalPulseRecipientsDetails);
      this.loading = false;
      if (this.total === 0) {
        this.errorRecipients = 0;
        this.warningRecipients = 0;
        let payload = {
          "error": this.errorRecipients,
          "warning": this.warningRecipients
        }
        this.errorCount.emit(payload);
      } else {
        this.getPulseMetaData();
      }
    },
      (err: any) => {
        this.loading = false;
        if (err.status === 404) {
          localStorage.removeItem('draft_pulse_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }
  resetDraftContent() {
    this.loading = true;
    this.retrievePulseDraftTableData()
    this.loading = false;
  }
}
